import {Button, Dropdown} from '@/components-v2'
import {useSelector} from 'react-redux'
import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import '@/containers/Promotions/components/SegmentSection/segmentGroup.scss'
import {segmentOptions} from '@/utils/constants/promotionConstants'
import {SegmentTags} from './SegmentTags'

export const SegmentGroup = ({
  groupIndex,
  segmentGroup,
  onSegmentSelection,
  dropdownLabel = '',
  tagsSeparator = 'AND',
  handleDeleteGroup = null,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleRemove = (_segmentId, _groupIndex) => {},
}) => {
  const allSegmentIds = segmentGroup?.segments || []
  const label = dropdownLabel || (groupIndex !== null ? `Group ${groupIndex + 1}` : 'Segments')

  const canDelete = groupIndex !== null && groupIndex > 0 && handleDeleteGroup !== null
  const countryCode = useSelector(selectCountryCode)
 const availableSegmentOptions =
    countryCode === 'MX' ? segmentOptions : segmentOptions.filter(option => option.id !== 'Create New Segment')
  return (
    <div>
      <div className="mb-4 flex items-center justify-start">
        <div className="products-admin-segment-section-tag-wrapper relative flex items-center gap-2">
          <Dropdown
            childList={availableSegmentOptions}
            placeholder="Select Segment(s)"
            label={label}
            setSelectedValue={items => onSegmentSelection(items, groupIndex)}
          />
        </div>

        {canDelete && (
          <Button onClick={() => handleDeleteGroup(groupIndex)} className="ml-4 mt-5" size="small" variant="tertiary">
            Delete Group
          </Button>
        )}
      </div>

      {allSegmentIds.length > 0 && (
        <div className="mt-4">
          <SegmentTags
            segments={allSegmentIds}
            handleTagRemove={segment => handleRemove(segment.segmentId, groupIndex)}
            separator={tagsSeparator}
          />
        </div>
      )}
    </div>
  )
}
